// extracted by mini-css-extract-plugin
export var content = "slack-module--content--h5lcU";
export var linksContainer = "slack-module--linksContainer--4J-nJ";
export var link = "slack-module--link--sLVnS";